document.querySelectorAll('.questions__item').forEach((item) => {
  item.addEventListener('click', (e) => {
    const currentItem = e.currentTarget as HTMLElement;
    const hiddenBlock = currentItem.querySelector('p');
    const use = currentItem.querySelector('use');
    if (hiddenBlock) {
      if (hiddenBlock?.classList.contains('hidden')) {
        hiddenBlock.classList.remove('hidden');
        hiddenBlock.style.maxHeight = hiddenBlock.scrollHeight + 'px';
        use?.setAttributeNS('http://www.w3.org/1999/xlink', 'href', './img/svg/sprite.svg#cancel');
      } else {
        hiddenBlock.style.maxHeight = '0px';
        hiddenBlock?.classList.add('hidden');
        use?.setAttributeNS('http://www.w3.org/1999/xlink', 'href', './img/svg/sprite.svg#plus');
      }
    }
  });
});
